import { render, staticRenderFns } from "./BlogDetailsPageItem.vue?vue&type=template&id=f7f8553e&scoped=true"
import script from "./BlogDetailsPageItem.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPageItem.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailsPageItem.vue?vue&type=style&index=0&id=f7f8553e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f8553e",
  null
  
)

export default component.exports